/**
 * Sanitizes free-text input for numeric form fields (including partial in-progress values like "-", ".", and "-.5").
 * Keeps digits, at most one decimal point, and an optional leading minus.
 * A decimal comma is converted to a dot (Helios convention: with both separators present,
 * the dot wins; without a dot, the last comma is the decimal separator).
 */
export const sanitizeNumericInput = (value: string): string => {
  let normalized = value;
  if (normalized.includes('.')) {
    normalized = normalized.replaceAll(',', '');
  } else {
    const lastComma = normalized.lastIndexOf(',');
    if (lastComma >= 0) {
      normalized = `${normalized.slice(0, lastComma).replaceAll(',', '')}.${normalized.slice(lastComma + 1)}`;
    }
  }

  return normalized
    .replace(/[^\d.-]/g, '')
    .replace(/(?!^)-/g, '')
    .replace(/^(-?\d*)\.([\d.]*)/, (_, intPart: string, fraction: string) => `${intPart}.${fraction.replace(/\./g, '')}`);
};
